import { useLanguage } from "@/App";
import { translations } from "@/i18n";
import { Reveal, Eyebrow } from "@/components/Reveal";

const BAR_COLORS = ["#D4AF37", "#3E7BD9", "#C8102E", "#D4AF37"];

const Process = () => {
  const { lang } = useLanguage();
  const t = translations[lang].process;

  return (
    <section id="how-we-help" data-testid="how-we-help-section" className="bg-[#060A1A] py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>{t.eyebrow}</Eyebrow>
          <h2 className="max-w-2xl font-display text-4xl font-black tracking-tighter text-white sm:text-5xl">
            {t.title}
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-12 md:grid-cols-4 md:gap-8">
          {t.steps.map((s, i) => (
            <Reveal key={`${lang}-${i}`} delay={i * 0.1}>
              <div data-testid={`process-step-${i}`} className="group relative">
                <span className="mb-6 block h-px w-full bg-white/10">
                  <span
                    className="block h-px transition-[width] duration-700 group-hover:w-full"
                    style={{ width: "25%", backgroundColor: BAR_COLORS[i] }}
                  />
                </span>
                <span className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#D4AF37]">
                  {s.num}
                </span>
                <h3 className="mt-4 font-display text-xl font-semibold tracking-tight text-white md:text-2xl">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm font-light leading-relaxed text-slate-300">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
